{
  "info": "Informatie",
  "negative": "Fout",
  "notice": "Waarschuwing",
  "positive": "Geslaagd"
}
